import Foundation from 'foundation-sites';

Foundation.Abide.defaults.validators['validate_state_selection'] = validateStateSelection;

function validateStateSelection(
    $el,      /* jQuery element to validate */
    required, /* is the element required according to the `[required]` attribute */
    parent    /* parent of the jQuery element `$el` */
) {
    var selectedValue = $el.val();
    var notValid = selectedValue.startsWith('PlaceHolder') || selectedValue.startsWith('selected');
    var $parent = $el.parent();
    
    if (!notValid) {
        $el.removeClass('invalid-no-selection');
        showFormErrorChildren($parent, '');
        $el.attr("aria-invalid", "false");
    } else {
        $el.addClass('invalid-no-selection');
        $el.attr("aria-invalid", "true");
        showFormErrorChildren($parent, 'invalid-no-selection');
    }

    return !notValid;
};

function showFormErrorChildren($parent, className)
{
    var children = $parent.children(".form-error");
    if (children.length)
    {
        for (var i=0; i < children.length; i++)
        {
            if (children[i].classList.contains(className))
            {
                children[i].classList.remove("is-hidden");
                children[i].classList.add("is-visible");
            } else {
                children[i].classList.add("is-hidden");
                children[i].classList.remove("is-visible");
            }
        }
    }
}
